export const SDButtonGroupOverrides = (direction, error) => {
  return {
    Root: {
      style: ({ $theme }) => {
        return {
          flexDirection: direction ?? 'initial',
          backgroundColor: '#EDEEEE',
          width: 'auto',
          marginLeft: '0.01rem',
          border: error ? `solid 2px #B30F16` : `solid 1px #EDEEEE`,
          borderTopRightRadius: $theme.borders.radius200,
          borderBottomRightRadius: $theme.borders.radius200,
          borderBottomLeftRadius: $theme.borders.radius200,
          borderTopLeftRadius: $theme.borders.radius200,
        }
      },
    },
  }
}
export const SDButtonGroupButtonOverrides = () => {
  return {
    BaseButton: {
      style: ({ $theme, $disabled, $isSelected }) => {
        const bgColour = $isSelected ? '#FFFFFF' : '#EDEEEE'
        const textColor = $disabled ? '#AAAAAA' : $isSelected ? '#015AA3' : 'inherit'
        const border = $isSelected ? '1px solid #015AA3' : '1px solid transparent'
        const hoverOutline = $disabled ? 'none' : '0.125rem solid #015AA3'

        return {
          flex: '1 1 auto',
          color: textColor,
          backgroundColor: bgColour,
          border,
          borderRadius: '.375rem',
          ':hover': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':focus': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':disabled': {
            backgroundColor: bgColour,
          },
          ':disabled :hover': {
            backgroundColor: bgColour,
          },
          ':disabled :focus': {
            backgroundColor: bgColour,
          },
          ':not(:last-child)': {
            marginRight: '.1875rem',
          },
        }
      },
    },
  }
}
